/* eslint-disable react/no-danger */
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
// eslint-disable-next-line import/no-cycle
import { Card } from "../../../sharedComponents/Card";
// eslint-disable-next-line import/no-cycle
import { Button } from "../../Button";
import * as styles from "./SquareCard.module.scss";

const SquareCard = ({ image, link, className, clickable }) => (
	<Card className={cx(styles.squareCard, className)}>
		<figure className={styles.squareCard__figure}>
			{image && (
				<Card.Image
					className={styles.squareCard__image}
					src={!image.source?.srcSet && image.src}
					source={image.source?.srcSet && image}
					alt={image.alt}
					fluid={image.fluid}
				/>
			)}
		</figure>
		<div>
			{link && (
				<Button
					to={link.to}
					theme={link?.theme || "primary-invert"}
					className={cx(styles.squareCard__button, {
						[styles.squareCard__buttonClickable]: clickable,
					})}>
					{link.text}
				</Button>
			)}
		</div>
	</Card>
);

SquareCard.propTypes = {
	image: PropTypes.shape({
		fluid: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
		fixed: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
		source: PropTypes.shape({
			src: PropTypes.string,
			srcSet: PropTypes.string,
			sizes: PropTypes.string,
		}),
		alt: PropTypes.string,
		src: PropTypes.string,
	}).isRequired,
	className: PropTypes.string,
	clickable: PropTypes.bool,
	link: PropTypes.shape({
		to: PropTypes.string.isRequired,
		target: PropTypes.string,
		text: PropTypes.string,
		theme: PropTypes.oneOf(["primary", "wedding", "booking-path", "primary-invert"]),
	}),
};

SquareCard.defaultProps = {
	link: null,
	className: "",
	clickable: true,
};

export default SquareCard;
export { SquareCard };
